import { Component, Input } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { ApprovalsService } from "src/app/services";

@Component({
   selector: "diagrams",
   templateUrl: "./diagrams.component.html",
   styleUrls: ["./diagrams.component.scss"],
})
export class DiagramsComponent {
   @Input() personId!: string;

   get currentDiagram() {
      return this.approvalsService.currentDiagrams?.find(d => this.idsMatch(d.personId, this.personId)) || null;
   }
   get imageSource() {
      if (!this.currentDiagram?.image) return null;
      return `data:image/jpeg;base64,${this.currentDiagram.image}`;
   }
   get diagramsLoaded() {
      return this.approvalsService.currentDiagramsLoaded;
   }
   get expectedDiagram() {
      return this.diagramModels.some(d => this.idsMatch(d.personId, this.personId));
   }
   get showMissingDiagramMessage() {
      return this.diagramsLoaded && this.expectedDiagram && !this.imageSource;
   }

   constructor(private approvalsService: ApprovalsService) {}

   private get diagramModels(): any[] {
      var dvr = this.approvalsService.currentDvr as FormGroup | null;
      var diagramModels = dvr?.get("diagrams")?.get("domesticViolenceDiagramModel") as FormArray | null;
      var values = diagramModels?.value;

      if (!values) return [];
      return Array.isArray(values) ? values : [values];
   }

   private idsMatch(first: string, second: string) {
      return this.normalizeId(first) === this.normalizeId(second);
   }

   private normalizeId(value: string) {
      return value ? value.toString().toLowerCase() : "";
   }
}
